
import React from "react";
import './section3.css';
import programacaoImg from '../../assets/participar/queroParticipar2.svg';

const Section3 = () => {
  return (
    <section className="section3">
      <div className="section3-container">
        <img
          src={programacaoImg}
          alt="Programação"
          className="section3-img animate-press"
        />
        <a
          href="https://euvou.events/42feiradenegocios2025@associadoscessionariosefranqueado"
          className="invisible-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="sr-only">Acessar link externo</span>
        </a>
      </div>
    </section>
  );
};

export default Section3;
